import { request } from './client';
import type { Card, CardInput, Deck, DeckInput } from './types';

/** Lists the user's decks, oldest first. */
export async function listDecks(signal?: AbortSignal): Promise<Deck[]> {
  const body = await request<{ decks: Deck[] }>('/decks', signal ? { signal } : {});

  return body.decks;
}

/** Returns one deck. */
export function getDeck(deckId: string, signal?: AbortSignal): Promise<Deck> {
  return request<Deck>(`/decks/${encodeURIComponent(deckId)}`, signal ? { signal } : {});
}

/** Creates a deck. */
export function createDeck(input: DeckInput): Promise<Deck> {
  return request<Deck>('/decks', { method: 'POST', body: input });
}

/** Replaces the title and description of a deck. */
export function updateDeck(deckId: string, input: DeckInput): Promise<Deck> {
  return request<Deck>(`/decks/${encodeURIComponent(deckId)}`, { method: 'PUT', body: input });
}

/** Deletes a deck and its cards. */
export function deleteDeck(deckId: string): Promise<void> {
  return request<undefined>(`/decks/${encodeURIComponent(deckId)}`, { method: 'DELETE' });
}

/** Lists the cards of a deck, oldest first. */
export async function listCards(deckId: string, signal?: AbortSignal): Promise<Card[]> {
  const body = await request<{ cards: Card[] }>(
    `/decks/${encodeURIComponent(deckId)}/cards`,
    signal ? { signal } : {},
  );

  return body.cards;
}

/** Adds a card to a deck. */
export function createCard(deckId: string, input: CardInput): Promise<Card> {
  return request<Card>(`/decks/${encodeURIComponent(deckId)}/cards`, {
    method: 'POST',
    body: input,
  });
}

/** Replaces the content of a card. */
export function updateCard(cardId: string, input: CardInput): Promise<Card> {
  return request<Card>(`/cards/${encodeURIComponent(cardId)}`, { method: 'PUT', body: input });
}

/** Deletes a card. */
export function deleteCard(cardId: string): Promise<void> {
  return request<undefined>(`/cards/${encodeURIComponent(cardId)}`, { method: 'DELETE' });
}
